module.exports = __webpack_public_path__ + "media/assessment-accelerator-intro.fcd12b76.mp4";